/*
 *
 * SettingsAlertPopup
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
 */
import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  modalTitle: <PortalMessage id='t.app.pci.protectionPlus.modalTitle' defaultMessage="Cos'è Protection Plus" />,
  modalDescriptionTop: (
    <PortalMessage
      id='t.app.pci.protectionPlus.modalDescriptionTop'
      defaultMessage='Ogni volta che accetti un pagamento elettronico, entri in contatto con alcuni dati estremamente rilevanti, tra cui il numero della carta, il nome e cognome del titolare, il codice PIN. Il furto di questi dati può portare a frodi e atti illeciti.'
    />
  ),
  modalProtectionQuote: (
    <PortalMessage
      id='t.app.pci.protectionPlus.modalProtectionQuote'
      defaultMessage='“Il 70% degli attacchi ai dati della carta avviene ai danni di esercenti di piccole e medie dimensioni”'
    />
  ),
  modalPrimaryButton: (
    <PortalMessage id='t.app.pci.protectionPlus.modalPrimaryButton' defaultMessage='guarda video dedicati' />
  ),
  modalProtectionSource: (
    <PortalMessage
      id='t.app.pci.protectionPlus.modalProtectionSource'
      defaultMessage='Fonte National Cyber Security Alleance, 2016'
    />
  ),
  modalProtectionProgressText: (
    <PortalMessage
      id='t.app.pci.protectionPlus.modalProtectionProgressText'
      defaultMessage='Per questo nasce Protection Plus di Nexi, la prima piattaforma online in cui avrai a tua disposizione:'
    />
  ),
  portalProgressStepper1: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper1'
      defaultMessage='Una completa formazione sullo standard PCI-DSS'
    />
  ),
  portalProgressStepper2: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper2'
      defaultMessage='Un questionario semplificato per la tua certificazione'
    />
  ),
  portalProgressStepper3: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper3'
      defaultMessage='L’attestazione di conformità allo standard PCI-DSS'
    />
  ),
  portalProgressStepper4: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper4'
      defaultMessage='Un piano di recupero dedicato, in caso di non conformità'
    />
  ),
  modalStepperTitle: (
    <PortalMessage
      id='t.app.pci.protectionPlus.modalStepperTitle'
      defaultMessage='I tuoi vantaggi'
    />
  ),
  portalProgressStepper5: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper5'
      defaultMessage='Riduzione del rischio di violazione dei dati delle carte'
    />
  ),
  portalProgressStepper6: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper6'
      defaultMessage='Rafforzamento della fiducia dei tuoi clienti'
    />
  ),
  portalProgressStepper7: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper7'
      defaultMessage='Manleva in caso di sanzioni per il furto dei dati'
    />
  ),
  portalProgressStepper8: (
    <PortalMessage
      id='t.app.pci.protectionPlus.portalProgressStepper8'
      defaultMessage='Identificazione dei fornitori di servizi di supporto'
    />
  ),
  modalDescriptionBottom: (
    <PortalMessage
      id='t.app.pci.protectionPlus.modalDescriptionBottom'
      defaultMessage="Ecco perché è sempre più importante tutelare la sicurezza dei pagamenti e la protezione dei dati dei tuoi
              clienti. Nexi, in accordo con tutti i soggetti che prendono parte al processo di pagamento, garantisce la
              sicurezza delle transazioni che avvengono sui circuiti nazionali ed internazionali. Ma è fondamentale il
              tuo contributo nell'adottare misure di protezione per la tutela dei dati."
    />
  )
}

export default formattedMessage
